export default __webpack_public_path__ + "static/images/login/background3.008c65673b93a4307a759ca7c803854e.png";